import { z } from 'zod'

export const clientFileSchema = z.object({
  id: z.number(),
  filePath: z.string(),
  fileName: z.string(),
  previewUrl: z.string(),
  downloadUrl: z.string(),
})

export type TClientFile = z.infer<typeof clientFileSchema>

export const metadataFileSchema = clientFileSchema.omit({ id: true }).extend({
  size: z.number(),
  /** Client-only; not sent as form field (upload uses restored File blob). */
  contentType: z.string().optional(),
})

export type TMetadataFile = z.infer<typeof metadataFileSchema>

export const attachmentResponseSchema = z.object({ attachmentId: z.number() })

export type TAttachmentResponse = z.infer<typeof attachmentResponseSchema>
